import PrimeVue, { type PrimeVueConfiguration } from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import DialogService from 'primevue/dialogservice'
import pt from '~~/primevue/pt'
import theme from '~~/primevue/style'

const config: PrimeVueConfiguration = {
  pt,
  theme,
  ripple: true,
  zIndex: {
    modal: 99999999,
    overlay: 99999999,
    menu: 99999999,
    tooltip: 99999999,
  },
}

export default defineNuxtPlugin({
  name: 'primevue',
  dependsOn: ['locale'],
  setup: async (nuxtApp) => {
    nuxtApp.vueApp.use(PrimeVue, config)
    nuxtApp.vueApp.use(ConfirmationService)
    nuxtApp.vueApp.use(ToastService)
    nuxtApp.vueApp.use(DialogService)

    const { setPrimeVueLocale } = useLocale()

    // await: locale JSON se importuje dynamicky; bez čekání by SSR/hydratace
    // mohla proběhnout s en_GB defaulty a klient pak s jiným jazykem.
    await setPrimeVueLocale(nuxtApp.vueApp.config.globalProperties.$primevue.config)
  },
})
